/**
 * @desc 批量顺延
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.wms.BatchPostponementRequestDto>, options?: any) {
  return updateResponse(
    http(URL + `/wms/changeOrder/batchPostponement`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
